/* eslint react/no-multi-comp: 0, react/prop-types: 0 */
import React from 'react';
import { PrismCode } from 'react-prism';
import Helmet from 'react-helmet';
import CourseCardBookedEmptyExample from '../examples/CourseCardBookedEmpty';
import CourseCardSkeletonExample from '../examples/CourseCardSkeleton';
import CourseCardPriceExample from '../examples/CourseCardPrice';
import CourseCardDiscountExample from '../examples/CourseCardDiscount';
import CourseCardProgressEnoughTimeExample from '../examples/CourseCardProgressEnoughTime';
import CourseCardProgressMissedDeadlineExample from '../examples/CourseCardProgressMissedDeadline';
import CourseCardFinishedExample from '../examples/CourseCardFinished';
import CourseCardTermWithoutProgressExample from '../examples/CourseCardTermWithoutProgress';
import CourseCardAbilitiesExample from '../examples/CourseCardAbilities';
import CourseCardPopularCompanyExample from '../examples/CourseCardPopularCompany';
import CourseCardRecommendedByStudentExample from '../examples/CourseCardRecommendedByStudent';
import ProgramCardDefaultExample from '../examples/ProgramCardDefault';
import ProgramCardTermWithProgressExample from '../examples/ProgramCardTermWithProgress';
import ProgramCardFinishedExample from '../examples/ProgramCardFinished';
import ProgramCardSkeletonExample from '../examples/ProgramCardSkeleton';
const CourseCardBookedEmptyExampleSource = require('!!raw-loader!../examples/CourseCardBookedEmpty');
const CourseCardSkeletonExampleSource = require('!!raw-loader!../examples/CourseCardSkeleton');
const CourseCardPriceExampleSource = require('!!raw-loader!../examples/CourseCardPrice');
const CourseCardDiscountExampleSource = require('!!raw-loader!../examples/CourseCardDiscount');
const CourseCardProgressEnoughTimeExampleSource = require('!!raw-loader!../examples/CourseCardProgressEnoughTime');
const CourseCardProgressMissedDeadlineExampleSource = require('!!raw-loader!../examples/CourseCardProgressMissedDeadline');
const CourseCardFinishedExampleSource = require('!!raw-loader!../examples/CourseCardFinished');
const CourseCardTermWithoutProgressExampleSource = require('!!raw-loader!../examples/CourseCardTermWithoutProgress');
const CourseCardAbilitiesExampleSource = require('!!raw-loader!../examples/CourseCardAbilities');
const CourseCardPopularCompanyExampleSource = require('!!raw-loader!../examples/CourseCardPopularCompany');
const CourseCardRecommendedByStudentExampleSource = require('!!raw-loader!../examples/CourseCardRecommendedByStudent');
const ProgramCardDefaultExampleSource = require('!!raw-loader!../examples/ProgramCardDefault');
const ProgramCardTermWithProgressExampleSource = require('!!raw-loader!../examples/ProgramCardTermWithProgress');
const ProgramCardFinishedExampleSource = require('!!raw-loader!../examples/ProgramCardFinished');
const ProgramCardSkeletonExampleSource = require('!!raw-loader!../examples/ProgramCardSkeleton');
export default class BoxesPage extends React.Component {
    render() {
        return (<div>
                <Helmet title="Advanced Cards"/>
                <h3>Education program card</h3>
                <p>
                    Cards of education programs (<code>card-program</code>) are derivative of <code>card-course</code>{' '}
                    and it's possible to set the same states.
                </p>
                <div className="docs-example bg-content">
                    <div className="row no-gutters">
                        <div className="col-12 col-md-6 mb-7">
                            <ProgramCardDefaultExample />
                        </div>
                        <div className="col-12 col-md-6 mb-7">
                            <ProgramCardTermWithProgressExample />
                        </div>
                        <div className="col-12 col-md-6 mb-7">
                            <ProgramCardFinishedExample />
                        </div>
                        <div className="col-12 col-md-6 mb-7">
                            <ProgramCardSkeletonExample />
                        </div>
                    </div>
                </div>
                <pre>
                    <PrismCode className="language-jsx">{ProgramCardDefaultExampleSource}</PrismCode>
                </pre>
                <pre>
                    <PrismCode className="language-jsx">{ProgramCardTermWithProgressExampleSource}</PrismCode>
                </pre>
                <pre>
                    <PrismCode className="language-jsx">{ProgramCardFinishedExampleSource}</PrismCode>
                </pre>
                <pre>
                    <PrismCode className="language-jsx">{ProgramCardSkeletonExampleSource}</PrismCode>
                </pre>
                <h3>Course card</h3>
                <p className="mb-0">
                    Basic course card without any state in footer of card, but it's marked as booked and there is left
                    corner badge.
                </p>
                <div className="docs-example bg-content">
                    <div className="row no-gutters">
                        <div className="col-12 col-md-4 mb-7">
                            <CourseCardBookedEmptyExample />
                        </div>
                        <div className="col-12 col-md-4 mb-7">
                            <CourseCardSkeletonExample />
                        </div>
                    </div>
                </div>
                <pre>
                    <PrismCode className="language-jsx">{CourseCardBookedEmptyExampleSource}</PrismCode>
                </pre>
                <pre>
                    <PrismCode className="language-jsx">{CourseCardSkeletonExampleSource}</PrismCode>
                </pre>
                <p className="mb-0 mt-8">
                    This use case is for B2C clients, when it's necessary to show price and discount.
                </p>
                <div className="docs-example bg-content">
                    <div className="row no-gutters">
                        <div className="col-12 col-md-4 mb-7">
                            <CourseCardPriceExample />
                        </div>
                        <div className="col-12 col-md-4 mb-7">
                            <CourseCardDiscountExample />
                        </div>
                    </div>
                </div>
                <pre>
                    <PrismCode className="language-jsx">{CourseCardPriceExampleSource}</PrismCode>
                </pre>
                <pre>
                    <PrismCode className="language-jsx">{CourseCardDiscountExampleSource}</PrismCode>
                </pre>
                <p className="mb-0 mt-8">
                    This is used for students who should start studying or ongoing study. The last use case is for
                    completed studies and student can download certification.
                </p>
                <div className="docs-example bg-content">
                    <div className="row no-gutters">
                        <div className="col-12 col-md-4 mb-7">
                            <CourseCardTermWithoutProgressExample />
                        </div>
                        <div className="col-12 col-md-4 mb-7">
                            <CourseCardProgressEnoughTimeExample />
                        </div>
                        <div className="col-12 col-md-4 mb-7">
                            <CourseCardProgressMissedDeadlineExample />
                        </div>
                        <div className="col-12 col-md-4 mb-7">
                            <CourseCardFinishedExample />
                        </div>
                    </div>
                </div>
                <pre>
                    <PrismCode className="language-jsx">{CourseCardTermWithoutProgressExampleSource}</PrismCode>
                </pre>
                <pre>
                    <PrismCode className="language-jsx">{CourseCardProgressEnoughTimeExampleSource}</PrismCode>
                </pre>
                <pre>
                    <PrismCode className="language-jsx">{CourseCardProgressMissedDeadlineExampleSource}</PrismCode>
                </pre>
                <pre>
                    <PrismCode className="language-jsx">{CourseCardFinishedExampleSource}</PrismCode>
                </pre>
                <p className="mb-0 mt-8">
                    Other use cases, which is used to fill the contents of the footer for B2B students.
                </p>
                <div className="docs-example bg-content">
                    <div className="row no-gutters">
                        <div className="col-12 col-md-4 mb-7">
                            <CourseCardAbilitiesExample />
                        </div>
                        <div className="col-12 col-md-4 mb-7">
                            <CourseCardPopularCompanyExample />
                        </div>
                        <div className="col-12 col-md-4 mb-7">
                            <CourseCardRecommendedByStudentExample />
                        </div>
                    </div>
                </div>
                <pre>
                    <PrismCode className="language-jsx">{CourseCardAbilitiesExampleSource}</PrismCode>
                </pre>
                <pre>
                    <PrismCode className="language-jsx">{CourseCardPopularCompanyExampleSource}</PrismCode>
                </pre>
                <pre>
                    <PrismCode className="language-jsx">{CourseCardRecommendedByStudentExampleSource}</PrismCode>
                </pre>
            </div>);
    }
}
